import { render, staticRenderFns } from "./TemplateCards.vue?vue&type=template&id=10d3f998&scoped=true&"
import script from "./TemplateCards.vue?vue&type=script&lang=js&"
export * from "./TemplateCards.vue?vue&type=script&lang=js&"
import style0 from "./TemplateCards.vue?vue&type=style&index=0&id=10d3f998&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d3f998",
  null
  
)

export default component.exports